export default __webpack_public_path__ + "static/media/Minicard_9c.738f5857.svg";